// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bbcR","input":"styles_input__17tDw"};